import styled from 'styled-components';

const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.5s ease;

  /* Top promo bar */
  .promo-bar {
    background: var(--clr-olive);
    color: var(--clr-warm-white);
    overflow: hidden;
    transition: all 0.5s ease;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
  }
  @media (min-width: 768px) {
    .promo-bar { height: 40px; }
  }
  .promo-bar p {
    font-family: var(--font-body);
    font-size: 0.65rem;
    letter-spacing: 0.03em;
    margin: 0;
    color: var(--clr-warm-white);
    text-align: center;
    white-space: nowrap;
    transition: opacity 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 95%;
  }
  @media (min-width: 768px) {
    .promo-bar p { font-size: 0.85rem; letter-spacing: 0.05em; }
  }
  &.scrolled .promo-bar {
    height: 0;
    overflow: hidden;
  }
  &.scrolled .promo-bar p { opacity: 0; }

  /* Main nav bar */
  .nav-main {
    transition: all 0.5s ease;
    background: transparent;
    margin: 0;
    padding: 0;
  }
  &.scrolled .nav-main {
    background: #ffffff !important;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  }
  
  /* Transparent nav at the top of the page (over olive hero sections) */
  &:not(.scrolled) .nav-main {
    background: transparent;
  }
  
  /* Olive nav at top for wishlist page */
  &.olive-top:not(.scrolled) .nav-main {
    background: var(--clr-olive);
  }
  
  /* Solid nav for non-home pages */
  &.solid-nav .nav-main {
    background: #ffffff;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
  }
  &.solid-nav .nav-logo a {
    color: var(--clr-charcoal);
  }
  &.solid-nav .nav-link {
    color: var(--clr-charcoal);
  }
  &.solid-nav .nav-link:hover {
    color: var(--clr-olive);
  }
  &.solid-nav .icon-btn {
    color: var(--clr-charcoal);
  }
  &.solid-nav .icon-btn:hover {
    color: var(--clr-olive);
    background: hsla(85, 30%, 32%, 0.08);
  }
  &.solid-nav .lang-toggle-nav {
    color: var(--clr-charcoal);
  }
  &.solid-nav .lang-toggle-nav:hover {
    color: var(--clr-olive);
    background: hsla(85, 30%, 32%, 0.08);
  }
  &.solid-nav .nav-toggle {
    color: var(--clr-charcoal);
  }
  &.solid-nav .profile-btn {
    border-color: var(--clr-beige-dark);
  }

  .nav-center {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
  }
  @media (min-width: 768px) {
    .nav-center { padding: 0 1.5rem; height: 76px; }
  }
  @media (min-width: 1024px) {
    .nav-center { padding: 0 2rem; }
  }

  /* Logo */
  .nav-logo a {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease;
  }
  .nav-logo-img {
    height: 90px;
    width: auto;
    object-fit: contain;
    transition: all 0.3s ease;
  }
  @media (min-width: 768px) {
    .nav-logo-img { height: 100px; }
  }
  &.scrolled .nav-logo a { }
  .nav-logo a:hover { opacity: 0.8; }

  /* Desktop Navigation Links */
  .nav-links {
    display: none;
    list-style: none;
    align-items: center;
    gap: 2rem;
    margin: 0;
    padding: 0;
  }
  @media (min-width: 992px) {
    .nav-links { display: flex; }
  }

  .nav-link {
    font-family: var(--font-body);
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;
    padding: 0.25rem 0;
    color: hsla(40, 30%, 99%, 0.8);
    white-space: nowrap;
    text-transform: capitalize;
    background: transparent;
    border: none;
    cursor: pointer;
  }
  &.scrolled .nav-link { color: var(--clr-charcoal) !important; }
  .nav-link:hover { color: var(--clr-warm-white); }
  &.scrolled .nav-link:hover { color: var(--clr-olive) !important; }

  .nav-link::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: var(--clr-olive);
    transition: width 0.3s ease;
  }
  .nav-link:hover::after { width: 100%; }

  .nav-link.highlight {
    color: var(--clr-gold) !important;
  }
  .nav-link.highlight::after { background: var(--clr-gold); }

  /* Right side icons */
  .nav-right {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  @media (min-width: 768px) {
    .nav-right { gap: 0.5rem; }
  }

  .nav-icons {
    display: flex;
    align-items: center;
    gap: 0;
  }
  @media (min-width: 768px) {
    .nav-icons { gap: 0.125rem; }
  }

  .icon-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    color: hsla(40, 30%, 99%, 0.8);
    text-decoration: none;
  }
  &.scrolled .icon-btn { color: var(--clr-charcoal) !important; }
  .icon-btn:hover {
    color: var(--clr-warm-white);
    background: hsla(40, 30%, 99%, 0.1);
    transform: scale(1.1);
  }
  &.scrolled .icon-btn:hover {
    color: var(--clr-olive) !important;
    background: hsla(85, 30%, 32%, 0.08);
  }
  .icon-btn svg { width: 20px; height: 20px; }

  .icon-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 16px;
    height: 16px;
    background: var(--clr-olive);
    color: var(--clr-warm-white);
    font-size: 10px;
    font-weight: 600;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-body);
    pointer-events: none;
  }

  /* Profile button */
  .profile-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid hsla(40, 30%, 99%, 0.3);
    transition: all 0.3s ease;
    text-decoration: none;
  }
  &.scrolled .profile-btn { border-color: var(--clr-beige-dark); }
  .profile-btn:hover { transform: scale(1.1); border-color: var(--clr-olive); }
  .profile-btn img { width: 100%; height: 100%; object-fit: cover; }

  /* Language toggle inside navbar */
  .lang-toggle-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.7rem;
    font-weight: 700;
    font-family: 'Arial', sans-serif;
    transition: all 0.3s ease;
    color: hsla(40, 30%, 99%, 0.8);
  }
  &.scrolled .lang-toggle-nav { color: var(--clr-charcoal) !important; }
  .lang-toggle-nav:hover {
    background: hsla(40, 30%, 99%, 0.1);
    color: var(--clr-warm-white);
  }
  &.scrolled .lang-toggle-nav:hover {
    background: hsla(85, 30%, 32%, 0.08);
    color: var(--clr-olive) !important;
  }

  /* Mobile toggle */
  .nav-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--clr-warm-white);
    transition: all 0.3s ease;
    margin-left: -0.5rem;
  }
  &.scrolled .nav-toggle { color: var(--clr-charcoal) !important; }
  .nav-toggle svg { width: 24px; height: 24px; }
  @media (min-width: 992px) {
    .nav-toggle { display: none; }
  }

  /* Search Overlay */
  .search-overlay {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--clr-warm-white);
    border-top: 1px solid var(--clr-beige);
    padding: 1.5rem;
    box-shadow: var(--shadow-card);
    animation: slideDown 0.3s ease;
  }
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .search-container {
    max-width: 600px;
    margin: 0 auto;
    position: relative;
  }
  .search-container input {
    width: 100%;
    padding: 0.85rem 1.25rem;
    padding-right: 3rem;
    border: 2px solid var(--clr-beige);
    border-radius: var(--radius);
    font-family: var(--font-body);
    font-size: 0.95rem;
    background: var(--clr-background);
    color: var(--clr-charcoal);
    outline: none;
    transition: border-color 0.3s ease;
  }
  .search-container input:focus { border-color: var(--clr-olive); }
  .search-container input::placeholder { color: var(--clr-charcoal-light); opacity: 0.6; }
  .search-icon {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--clr-charcoal-light);
    font-size: 1rem;
  }

  /* Hide sidebar-open */
  &.sidebar-open {
    @media (max-width: 991px) {
      transform: translateY(-100%);
      opacity: 0;
      pointer-events: none;
    }
  }
`;

export default NavContainer;
